import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ShipmentsService } from 'src/app/core/services/basicServices/shipments.service';
import { DataService } from 'src/app/core/services/data.service';
import { SelectionModel } from '@angular/cdk/collections';
import { AddEditProductComponent } from './add-edit-product/add-edit-product.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss']
})
export class ProductComponent implements OnInit {

  displayedColumns: string[] = ['productNo','name','dimUnit','length','width','height','weightUnit','weight','actions'];
  dataSource = new MatTableDataSource<any>();
  @ViewChild('paginator',{static:true}) paginator: MatPaginator;
  modalOptions:NgbModalOptions={};
  selection = new SelectionModel<any>(true, []);
  tableModel = {start:0,limit:10,sort:'',order:'' };
  modalRef:any;
  total=0
  constructor(private shipmentService:ShipmentsService,private modalService: NgbModal, private dataService: DataService,
    public router: Router,public Alerts: MatSnackBar,public dialog: MatDialog,) {}

    ngOnInit() {
    this.dataTableConfig();
  }
  
  openFormModal() {
    console.log(
      this.selection.selected);
    let m = {
      data: [],
      path: 'assets/reports/PackingSlip.xml',
    };
    this.dataService.passData(m);
    this.router.navigate(['/packing-slip']);
  }

  getList(){
    this.shipmentService.getAllProductDimensionsByProc(this.tableModel).subscribe(res=>{
      if(res){
        console.log(res)
        this.dataSource.data=res.dataList;
        this.total=res.totalCount;
        this.paginator.length = this.total;
      }
      else{
        this.dataSource.data=[];
      }
    })
  }

  dataTableConfig() {
    this.getList();
  }

   /** Whether the number of selected elements matches the total number of rows. */
   isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  openModal(id?: number) {
    const dialogRef = this.dialog.open(AddEditProductComponent, {
      width: "600px",
      data: { id: id },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.dataTableConfig();
      }
    });
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.data.forEach(row => this.selection.select(row));
  }

  
  onPaginate(pageEvent:any) {
    if(this.tableModel.limit == pageEvent.pageSize){
      this.tableModel.limit = pageEvent.pageSize;
      this.tableModel.start = (pageEvent.pageIndex) * pageEvent.pageSize;

    }
    else{
      this.tableModel.limit = pageEvent.pageSize;
      this.tableModel.start = 0;
    }
    this.getList();
  }
}
